<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="alibabapayment global__scrollcustom">
          <div class="d-flex align-items-center ">
            <div class="alibabapayment__wrapper clearfix">
              <keep-alive>
                <component
                  :is="currentStepComponent"
                  @ispaymentpage="paymentPage"
                  @iswelcomepage="welcome"
                  >
                </component>
              </keep-alive>
            </div>
          </div>
        </div>  <!-- end class -->
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import Payment from '@/components/paymentAlibaba/Payment.vue'
import WelcomePage from '@/components/paymentAlibaba/WelcomePage.vue'

export default {
  name: 'alibaba-payment',
  components: {
    Sidebar,
    Payment,
    WelcomePage
  },
  data () {
    return {
      activeContent: WelcomePage
    }
  },
  computed: {
    currentStepComponent () {
      return this.activeContent
    }
  },
  methods: {
    welcome () {
      this.activeContent = WelcomePage
    },
    paymentPage () {
      this.activeContent = Payment
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/paymentAlibaba/index.vue